module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("T")]), _vm._v("hree")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E GOTTA PLAN")]), _vm._v(" your bachelor party,” Brian Richter remarked as he finished rolling a joint. “Or rather "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" do. All you gotta do is gimme a night, and leave everything else to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No party,” Evan Richter answered stubbornly. They were sitting around a long table covered with scribbled-on script pages in a hotel room in Arizona, where they were on location for their current movie, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Space Blonde.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?” Brian said, lighting up the joint.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve been a bachelor forever,” Evan said, annoyed that he had to explain. “Did enough partying to last a lifetime, so what’ve "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" got to prove?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You gotta be shittin’ me?” Brian said with a disgusted look. “Bachelor parties are the only sane reason for getting married. If you’re gonna lock yourself up in pussy prison, you may as well fuck your balls off before your old lady "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("cuts")]), _vm._v(" ’em off.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“You’re sick,” Evan muttered.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m")]), _vm._v(" normal,” Brian retorted, dragging deeply on his joint. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“You’re")]), _vm._v(" the fucked-up member of the family.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a tragedy we weren’t separated at birth,” Evan muttered, wishing it were so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That would’ve suited me just fine,” Brian retorted. “And I’m sure Mom wouldn’t’ve minded.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Richter brothers. Fraternal twins. Totally unlike physically. Evan, quirky and nice looking, but no hunk with his spiky brown hair and lanky frame. Whereas Brian was all piercing blue eyes, shaggy beach-blond hair, and a hard body. In spite of Brian’s bad-boy habits—which included gambling, drinking too much, drugging a lot, and indiscriminately sleeping with a variety of nubile females—he was in excellent shape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Richter brothers. Hot properties in Hollywood. Hot and unpredictable. Some thought Evan was the one with all the talent because he appeared to be more serious than Brian. But Brian was the one with the best ideas. And Brian was the one who came up with the main story line and wrote most of the scripts. It was Evan who kept it all together, handled the financial aspects, could unfailingly close any deal, and made sure their movies came in on time and usually under budget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Richter brothers were always arguing; it amazed everyone who came in contact with them how they were able to maintain such a successful working relationship. Bicker, bicker, bicker. Day and night they went at it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Often they threatened to dissolve their partnership and go their separate ways. But usually sanity soon prevailed, because why mess with something that was making them both more money than they could ever have imagined?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" dear little Nicci?” Brian asked sarcastically. “Still calling you six times a day?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“We alternate,” Evan muttered, wondering why he was even bothering to explain.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bullshit,” Brian said disbelievingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How come you’re always on her case?” Evan responded, frowning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“ ’Cause she’s nothing but a needy kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evan glared at his brother. “Like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" date adults,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("date")]), _vm._v(" ’em, don’t marry ’em,” Brian pointed out. “Marriage is for old people who can’t get it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fortunately, Teena, their script assistant, rushed into the room, speaking into a cell phone. Short and in her thirties, she was an eccentric-looking woman with hair like straw, decorated with various colored clips and slides—plus a bold blue streak. Her round face was made to seem more so by the addition of huge wire-rimmed glasses, and she had a prominent snub nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s up?” Evan said, happy for the interruption, because he was not about to get into a discussion about why he was marrying Nicci with his sex-crazed brother. It was none of his business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything,” Teena said, clicking off the phone and rolling her purple-shadowed eyes. “Abbey doesn’t care for her new lines. Harry is under the impression that his trailer is smaller than hers. And Chris can’t handle it. He’s apparently gone into a funk. We’d better get over to the location, pronto.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abbey Christian—a leggy, twenty-two-year-old natural blonde, with a smile that could light up Christmas. Star of their latest movie. Major player. Major cokehead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harry Bello—big-deal comedy actor supreme. Rubber faced and coming up to fifty. Paranoid about getting older and quite certain that Abbey was receiving better treatment than he was.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Chris Fortune. Boy-wonder director. The same age as Abbey and somewhat intimidated by his two stars—even though he’d directed the big sleeper hit of the previous summer.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Freakin’ actors,” Brian grumbled, exhaling smoke. “We should be making "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("animated")]), _vm._v(" movies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You finally came up with a decent idea,” Evan said. “No more over-the-top salaries.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, guys, let’s move it,” Teena urged, almost jumping up and down with agitation. “Abbey won’t come out of her trailer. Harry’s sulking. And Chris is heading for a panic attack. We "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("must")]), _vm._v(" get over there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go,” Brian said, carefully preserving his joint in a Kleenex for later. “Nothing like a view of Abbey’s tits to wake me up in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember,” Evan said ominously. “No fucking our star until the movie wraps.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” Brian said innocently. “I can look, can’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISSA")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMAN")]), _vm._v(" went to great lengths to keep her private life private. Which was not easy considering she lived under constant media scrutiny. Danny, her assistant, was a big help. Earlier that day she’d instructed him to hire a car, leave it in the parking lot at Saks, and give her the ticket. He’d done so, no questions asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After lunch, she’d had Chuck drop her off at Barneys, instructed him to come back in two hours, walked across to Saks, got into the rented car, and driven out to the valley. There was no way she planned to alert Gregg to what was going on, or anyone else for that matter. This was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("her")]), _vm._v(" business, and when Lissa wanted to keep something private, she knew how to do it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Anyway, she was quite capable of driving to the valley ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("on her own. She didn’t need security, just a pair of dark glasses and a baseball cap to hide her telltale platinum hair. Besides, it was an adventure to be doing something on her own for a change.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She put on talk radio and listened to the various callins, which was always a trip, until finally she arrived at the Robbins/Scorsinni offices on Ventura, where she was greeted by a plump, middle-aged Asian assistant in a flowered pantsuit. The offices were old and kind of run-down, but Lissa felt quite comfortable. She wasn’t looking for one of those hotshot Hollywood P.I. agencies that knew everyone’s business. This low-key place suited her fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quincy Robbins, who ran the private investigation/ security agency with his partner, Michael Scorsinni, was a pleasant, reliable man, whom Lissa had used on several other occasions for various matters. He and his partner were ex-New York detectives, and that made her feel secure. When she’d moved into her house several years ago, she’d hired Quincy to be her chief security advisor. She’d never met his partner, but she knew that his reputation was stellar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take a seat, please,” the Asian woman said with a gummy smile, revealing a row of uneven teeth. “I am Mai Lee. Michael will be with you soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not here to see Michael,” Lissa said, anxious to get this over with. “Quincy is expecting me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody contacted you?” Mai Lee said, sounding surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not that I know of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh dear,” Mai Lee said, now highly embarrassed. “I think "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" was supposed to call you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“About what?” Lissa said, fast losing her patience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quincy’s laid up at home,” Mai Lee said, fluttering her hands. “He broke his leg.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“You’ve "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("got")]), _vm._v(" to be kidding?”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m afraid it’s true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“When")]), _vm._v(" did this happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A few days ago. But not to worry, Michael took over your case. You’ll be happy with Michael, he is most capable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa stood up. “I always deal with Quincy,” she said tightly. “This could’ve waited if I’d known he wasn’t available.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My fault,” Mai Lee said, now taking full responsibility. “I was supposed to explain. You see, Quincy didn’t seem to think you would "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("want")]), _vm._v(" to wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa wondered how much Mai Lee knew. This was so embarrassing, she could see the headlines now—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LISSA ROMAN CATCHES ANOTHER CHEATING HUSBAND")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, God!” she sighed, realizing there was nothing she could do at this late stage. “I suppose I’ll have to see Michael. Where is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” Mai Lee said apologetically. “He’s out of the office right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was ridiculous, she’d driven all the way out to the valley, and now she was getting a runaround. “Are you telling me that you expect me to sit here and wait?” she said sharply. It wasn’t often she played the star, but one perk of star treatment was never having to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’ll be back soon,” Mai Lee volunteered. “Very soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unbelievable!” Lissa muttered irritably. “I drove over here especially.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s plenty of magazines,” Mai Lee offered soothingly. “Why don’t you sit down and relax?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Why don’t")]), _vm._v(" you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("shove it up your ass,")]), _vm._v(" Lissa wanted to say, but she didn’t. That would have been mean and petty, ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("and one thing she was always careful about was preserving a good public image.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m nervous,")]), _vm._v(" she thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m nervous because even though I know for sure that Gregg’s screwing around, it’s still difficult to deal with.")]), _vm._v(" At least Quincy—big, black, comfortable Quincy—would have held her hand and said, “Listen, this is something you’re not gonna want to hear, but these are the facts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now she had to hear it from a stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, not exactly a stranger, Quincy had often mentioned his partner’s name. “My friend Michael,” he’d always say. “You should’ve seen us when we were detectives together in New York. Michael got shot, nearly bought it. You’ll like him. He’s one of the good guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And yet over the years she’d never met him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sat down, picked up a magazine, and flipped the pages impatiently, until suddenly the door was pushed open and a tall man strode in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Michael,” Mai Lee said, jumping up. “Ms. Roman is here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He walked right over to her. “Sorry to have kept you waiting,” he said. “Quincy insisted I shouldn’t make you wait, but it was unavoidable. I’m really sorry,” he added, giving her a long, sincere stare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had the blackest eyes she’d ever seen, thick jet hair, and dark olive skin with a two-day stubble. He was handsome, with a dangerous edge—an irresistible combination.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("So this is Michael Scorsinni,")]), _vm._v(" she thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Quincy never told me he looks like a movie star—only better.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh . . . hi,” she said, and wondered if this might turn out to be easier than she’d thought.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ecf8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 81
// module chunks = 0